import { Injectable } from '@angular/core';

export class CustomPropertyData {
  lCustomPropertyDataId: string;
  lCustomPropertyId: number;
  CustomProperty: string;
  lCustomPropertyDataTypeId: number;
  Control: string;
  lEntityGroupId: number;
  CustomPropertyItemSourceParameter: string;
  DisplayOrder: number;
  EntityGroup: string;
  lCustomPropertyValueId: number;
  lDataInstanceId: number;
  Value: any;
  CustomPropertyDataType: string;
  ItemSource: any;
  DefaultValue: string;
  FormatString: string;
  Min: number;
  Max: number;
  TextSize: number;
  Height: number;
  MultiSelectedItems: any[];
  opened: boolean;
  FileDetail: any;
  ReferenceDataTextBoxVisible: number;
  ReferenceDataURLVisible: number;
  EntityState: number;
  IsReadOnly: number;
  AddTodayButton: any;
  lTradingEntityId?: number;
}


export class CustomPropertyConfig {
  lCustomPropertyConfigId: number;
  FilePath: string;
  AllowedFileTypes: string;
}

export class JSONCurrentInstanceData {
  DataCaption: string;
  DataValue: string;
}

export class FileDetail {
  FileName: string;
  DataCaption: string;
  FileContent: any;
  lCustomPropertyDataId: string;
  FilePath: string;
}

export class CustomPropertyValue 
{
  lCustomPropertyValueId: number;
  lCustomPropertyId: number;
  lDataInstanceId: number;
  Value: string;
  EntityState: number;
  lTradingEntityId?: number;
}

export class ItemSource {
  DisplayMember: string;
}
export class CustomProperty {
  public lCustomPropertyId: number;
  public CustomPropertyName: string;
  public lCustomPropertyDataTypeId?: number;
  public Control: string;
  public lEntityGroupId?: number;
  public CustomPropertyItemSourceParameter: string;
  public CustomPropertyValues: any[] = [];
  EntityState: number;
}
